(function () {
  const SINGLE_OPEN   = false;
  const DURATION_MS   = 240;
  const EASING        = 'ease';
  const PAD_OPEN_PX   = 16;
  const PAD_CLOSE_PX  = 0;

  const REDUCED_MOTION =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFAQAccordion() {
    const list = document.querySelector('.p-faq__list');
    if (!list) return;

    const items = list.querySelectorAll('.p-faq__item');

    items.forEach((item, i) => {
      const q = item.querySelector('.p-faq__question');
      const a = item.querySelector('.p-faq__answer');
      if (!q || !a) return;

      q.setAttribute('role', 'button');
      q.setAttribute('tabindex', '0');
      q.setAttribute('aria-expanded', 'false');
      if (!q.id) q.id = `faq-question-${i}`;
      if (!a.id) a.id = `faq-answer-${i}`;
      q.setAttribute('aria-controls', a.id);
      a.setAttribute('aria-labelledby', q.id);
      a.setAttribute('aria-hidden', 'true');

      a.style.overflow   = 'hidden';
      a.style.display    = 'block';
      a.style.height     = '0px';
      a.style.opacity    = '0';
      a.style.paddingTop = PAD_CLOSE_PX + 'px';
      a.style.paddingBottom = PAD_CLOSE_PX + 'px';
      a.style.transition = `height ${REDUCED_MOTION ? 0 : DURATION_MS}ms ${EASING}, opacity ${REDUCED_MOTION ? 0 : DURATION_MS}ms ${EASING}`;
    });

    function onTransitionEndOnce(el, cb) {
      let done = false;
      const handler = (e) => {
        if (done) return;
        if (e.propertyName !== 'height') return;
        done = true;
        cleanup();
        cb();
      };
      const cleanup = () => {
        el.removeEventListener('transitionend', handler);
        el.removeEventListener('webkitTransitionEnd', handler);
      };
      el.addEventListener('transitionend', handler);
      el.addEventListener('webkitTransitionEnd', handler);
      const timer = setTimeout(() => {
        if (done) return;
        done = true;
        cleanup();
        cb();
      }, DURATION_MS + 80);
      return () => { clearTimeout(timer); cleanup(); };
    }

    function openItem(item) {
      if (item.classList.contains('is-open') || item.dataset.animating === '1') return;

      if (SINGLE_OPEN) {
        items.forEach((it) => { if (it !== item) closeItem(it); });
      }

      const q = item.querySelector('.p-faq__question');
      const a = item.querySelector('.p-faq__answer');
      if (!q || !a) return;

      item.dataset.animating = '1';
      item.classList.add('is-open');
      q.setAttribute('aria-expanded', 'true');
      a.setAttribute('aria-hidden', 'false');

      a.style.overflow = 'hidden';
      a.style.display  = 'block';
      a.style.opacity  = '0';
      a.style.height   = '0px';

      a.style.paddingTop    = PAD_OPEN_PX + 'px';
      a.style.paddingBottom = PAD_OPEN_PX + 'px';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const target = a.scrollHeight;
          if (REDUCED_MOTION) {
            a.style.opacity = '1';
            a.style.height  = 'auto';
            a.style.overflow = 'visible';
            delete item.dataset.animating;
            return;
          }

          a.style.height  = target + 'px';
          a.style.opacity = '1';

          const off = onTransitionEndOnce(a, () => {
            a.style.height   = 'auto';
            a.style.overflow = 'visible';
            delete item.dataset.animating;
            off && off();
          });
        });
      });
    }

    function closeItem(item) {
      if (!item.classList.contains('is-open') || item.dataset.animating === '1') return;

      const q = item.querySelector('.p-faq__question');
      const a = item.querySelector('.p-faq__answer');
      if (!q || !a) return;

      item.dataset.animating = '1';
      q.setAttribute('aria-expanded', 'false');
      a.setAttribute('aria-hidden', 'true');

      a.style.overflow = 'hidden';

      const current = a.scrollHeight;
      a.style.height  = current + 'px';
      a.style.opacity = '1';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (REDUCED_MOTION) {
            a.style.height = '0px';
            a.style.opacity = '0';
            a.style.paddingTop = PAD_CLOSE_PX + 'px';
            a.style.paddingBottom = PAD_CLOSE_PX + 'px';
            item.classList.remove('is-open');
            delete item.dataset.animating;
            return;
          }

          a.style.height = '0px';
          a.style.opacity = '0';

          const off = onTransitionEndOnce(a, () => {
            item.classList.remove('is-open');
            a.style.paddingTop = PAD_CLOSE_PX + 'px';
            a.style.paddingBottom = PAD_CLOSE_PX + 'px';
            delete item.dataset.animating;
            off && off();
          });
        });
      });
    }

    function toggleItem(item) {
      if (item.classList.contains('is-open')) closeItem(item);
      else openItem(item);
    }

    list.addEventListener('click', (e) => {
      const q = e.target.closest('.p-faq__question');
      if (!q || !list.contains(q)) return;
      const item = q.closest('.p-faq__item');
      if (item) toggleItem(item);
    });

    list.addEventListener('keydown', (e) => {
      const q = e.target.closest('.p-faq__question');
      if (!q || !list.contains(q)) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const item = q.closest('.p-faq__item');
        if (item) toggleItem(item);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQAccordion);
  } else {
    initFAQAccordion();
  }
})();



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.p-02__slider').forEach(function (el) {
    new Splide(el, {
      type: 'loop',
      focus: 'center',
      perPage: 4,
      fixedWidth: null,
      gap: '8px',
      drag: 'free',
      pauseOnFocus: false,
      pauseOnHover: false,
      arrows: false,
      pagination: false,
      autoScroll: { speed: 1 },
      breakpoints: {
        768: {
          perPage: false,
          fixedWidth: 200
        }
      },
    }).mount(window.splide.Extensions);
  });
});
  
document.addEventListener('DOMContentLoaded', function () {
  if (!window.Splide) return;

  var root = document.querySelector('.p-03__slider');
  if (!root) return;

  var story = root.closest('.p-03__story') || root.parentElement;
  var nav = document.querySelector('.p-03__nav');

  if (!nav && story && story.parentNode) {
    nav = document.createElement('div');
    nav.className = 'p-03__nav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'p-03__arrow p-03__arrow--prev';

    var pager = document.createElement('ul');
    pager.className = 'p-03__pagination';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'p-03__arrow p-03__arrow--next';

    nav.appendChild(prev);
    nav.appendChild(pager);
    nav.appendChild(next);
    story.parentNode.insertBefore(nav, story.nextSibling);
  }

  var prevBtn = nav && nav.querySelector('.p-03__arrow--prev');
  var nextBtn = nav && nav.querySelector('.p-03__arrow--next');
  var pagerEl = nav && nav.querySelector('.p-03__pagination');

  var splide = new Splide(root, {
    type: 'loop',
    focus: 'center',
    perPage: 1,
    gap: '24px',
    padding: { left: '0', right: '0' },
    arrows: false,
    pagination: false,
    speed: 300,
    easing: 'ease',
    breakpoints: {
      768: {
        gap: '8px',
        padding: { left: '0', right: '0' },
      },
    },
  });

  
  function buildPagerNumbers() {
    if (!pagerEl) return;
    pagerEl.innerHTML = '';
    var len = splide.length || 0;
    for (var i = 0; i < len; i++) {
      var li = document.createElement('li');
      li.className = 'p-03__dot p-03__dot--num';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'p-03__numBtn';
      btn.textContent = (i + 1).toString();
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      (function (index) {
        btn.addEventListener('click', function () { splide.go(index); });
      })(i);
      li.appendChild(btn);
      pagerEl.appendChild(li);

      if (i < len - 1) {
        var liSep = document.createElement('li');
        liSep.className = 'p-03__sep';
        liSep.setAttribute('aria-hidden', 'true');
        liSep.setAttribute('role', 'presentation');
        liSep.textContent = '/';
        pagerEl.appendChild(liSep);
      }
    }
    updatePagerActive();
  }

  function updatePagerActive() {
    if (!pagerEl) return;
    var items = pagerEl.querySelectorAll('.p-03__dot');
    var len = items.length;
    if (!len) return;
    var real = ((splide.index % len) + len) % len;
    for (var i = 0; i < len; i++) {
      items[i].classList.toggle('is-active', i === real);
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', function(){ splide.go('<'); });
  if (nextBtn) nextBtn.addEventListener('click', function(){ splide.go('>'); });

  splide.on('mounted', buildPagerNumbers);
  splide.on('updated', buildPagerNumbers);
  splide.on('move', updatePagerActive);

  splide.mount();
});


document.addEventListener('DOMContentLoaded', function () {
  if (!window.Splide) return;

  document.querySelectorAll('.p-04__voice').forEach(function (section) {
    var root = section.querySelector('.p-04__slider');
    if (!root) return;

    var nav = section.querySelector('.p-03__nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'p-03__nav';

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'p-03__arrow p-03__arrow--prev';

      var pager = document.createElement('ul');
      pager.className = 'p-03__pagination';

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'p-03__arrow p-03__arrow--next';

      nav.appendChild(prev);
      nav.appendChild(pager);
      nav.appendChild(next);
      section.appendChild(nav);
    }

    var prevBtn = nav.querySelector('.p-03__arrow--prev');
    var nextBtn = nav.querySelector('.p-03__arrow--next');
    var pagerEl = nav.querySelector('.p-03__pagination');

    var splide = new Splide(root, {
      type: 'loop',
      focus: 'center',
      fixedWidth: 314,
      perMove: 1,
      arrows: false,
      pagination: false,
      gap: '8px',
      drag: true,
      speed: 600,
      easing: 'cubic-bezier(.2,.6,0,1)',
      breakpoints: {
        768: {
          fixedWidth: 0,
          perPage: 1,
          padding: { left: '10%', right: '10%' },
          gap: '8px',
        },
      },
      trimSpace: false,
      flickPower: 300,
      flickMaxPages: 1,
      updateOnMove: true,
    });

    function buildDots() {
      if (!pagerEl) return;
      pagerEl.innerHTML = '';
      var len = splide.length || 0;
      for (var i = 0; i < len; i++) {
        var dot = document.createElement('li');
        dot.className = 'p-03__dot';
        (function (index) {
          dot.addEventListener('click', function () { splide.go(index); });
        })(i);
        pagerEl.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!pagerEl) return;
      var dots = pagerEl.querySelectorAll('.p-03__dot');
      var len = dots.length;
      if (!len) return;
      var real = ((splide.index % len) + len) % len;
      for (var i = 0; i < len; i++) {
        dots[i].classList.toggle('is-active', i === real);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function(){ splide.go('<'); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ splide.go('>'); });

    root.querySelectorAll('img').forEach(function(img){
      if (img.complete) return;
      img.addEventListener('load', function(){ splide.refresh(); });
      img.addEventListener('error', function(){ splide.refresh(); });
    });

    splide.on('mounted', buildDots);
    splide.on('updated', buildDots);
    splide.on('resize', function(){
      buildDots();
      splide.refresh();
    });
    splide.on('move', updateDots);
    splide.on('refresh', updateDots);

    splide.mount();
  });
});


document.addEventListener('DOMContentLoaded', function () {
  if (!window.Splide) return;

  var awardsGrid = document.querySelector('.p-04__awards');
  if (!awardsGrid) return;

  var mq = window.matchMedia('(max-width: 768px)');
  var sliderEl = null;
  var pagerEl  = null;
  var splide   = null;

  function mountAwardsSlider() {
    if (splide) return;
    sliderEl = document.createElement('div');
    sliderEl.className = 'splide p-04__awardsSlider';

    var track = document.createElement('div');
    track.className = 'splide__track';

    var list = document.createElement('ul');
    list.className = 'splide__list';

    track.appendChild(list);
    sliderEl.appendChild(track);

    awardsGrid.querySelectorAll('.p-04Award').forEach(function (card) {
      var li = document.createElement('li');
      li.className = 'splide__slide';
      li.appendChild(card.cloneNode(true));
      list.appendChild(li);
    });

    awardsGrid.insertAdjacentElement('afterend', sliderEl);

    pagerEl = document.createElement('ul');
    pagerEl.className = 'p-03__pagination';
    sliderEl.insertAdjacentElement('afterend', pagerEl);

    awardsGrid.style.display = 'none';

    splide = new Splide(sliderEl, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: false,
      gap: '16px',
      speed: 600,
      drag: true,
      easing: 'cubic-bezier(.2,.6,0,1)',
    });

    function buildDots() {
      if (!pagerEl) return;
      pagerEl.innerHTML = '';
      var len = splide.length || 0;
      for (var i = 0; i < len; i++) {
        var dot = document.createElement('li');
        dot.className = 'p-03__dot';
        (function (index) {
          dot.addEventListener('click', function () { splide.go(index); });
        })(i);
        pagerEl.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!pagerEl) return;
      var dots = pagerEl.querySelectorAll('.p-03__dot');
      var len = dots.length;
      if (!len) return;
      var real = ((splide.index % len) + len) % len;
      for (var i = 0; i < len; i++) {
        dots[i].classList.toggle('is-active', i === real);
      }
    }

    splide.on('mounted', buildDots);
    splide.on('updated', buildDots);
    splide.on('move', updateDots);
    splide.on('refresh', updateDots);

    splide.mount();
  }

  function unmountAwardsSlider() {
    if (!splide) return;
    splide.destroy(true);
    splide = null;

    if (sliderEl) { sliderEl.remove(); sliderEl = null; }
    if (pagerEl)  { pagerEl.remove();  pagerEl  = null; }

    awardsGrid.style.display = '';
  }

  function applyMode() {
    if (mq.matches) {
      mountAwardsSlider();
    } else {
      unmountAwardsSlider();
    }
  }

  if (mq.addEventListener) mq.addEventListener('change', applyMode);
  else mq.addListener(applyMode);
  applyMode();
});


document.addEventListener('DOMContentLoaded', function () {
  var feet = document.querySelectorAll('.p-06Profile__foot');
  if (!feet.length) return;

  var DURATION = 240;
  var EASING   = 'ease';
  var PAD_OPEN = 24;
  var PAD_CLOSE = 0;
  var REDUCED  = window.matchMedia &&
                 window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onTransitionEndOnce(el, cb) {
    var done = false;
    function handler(e) {
      if (done) return;
      if (e && e.propertyName !== 'height') return;
      done = true;
      cleanup();
      cb();
    }
    function cleanup() {
      el.removeEventListener('transitionend', handler);
      el.removeEventListener('webkitTransitionEnd', handler);
    }
    el.addEventListener('transitionend', handler);
    el.addEventListener('webkitTransitionEnd', handler);
    var timer = setTimeout(function () {
      if (done) return;
      done = true;
      cleanup();
      cb();
    }, DURATION + 100);
    return function off() { clearTimeout(timer); cleanup(); };
  }

  feet.forEach(function (foot, idx) {
    var btn   = foot.querySelector('.p-06Profile__more');
    var panel = foot.querySelector('.p-06Profile__moreDetail');
    if (!btn || !panel) return;

    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    if (!panel.id) panel.id = 'p06-more-' + idx;
    btn.setAttribute('aria-controls', panel.id);

    var transition = 'height ' + (REDUCED ? 0 : DURATION) + 'ms ' + EASING +
                     ', opacity ' + (REDUCED ? 0 : DURATION) + 'ms ' + EASING;

    btn.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.style.boxSizing = 'border-box';
    panel.style.willChange = 'height, opacity';
    panel.style.overflow = 'hidden';
    panel.style.display = 'block';
    panel.style.height = '0px';
    panel.style.opacity = '0';
    panel.style.paddingTop = PAD_CLOSE + 'px';
    panel.style.paddingBottom = PAD_CLOSE + 'px';
    panel.style.transition = transition;

    function open() {
      if (panel.dataset.animating === '1' || foot.classList.contains('is-open')) return;
      panel.dataset.animating = '1';

      foot.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');

      panel.style.overflow = 'hidden';
      panel.style.display  = 'block';
      panel.style.opacity  = '0';
      panel.style.height   = '0px';
      panel.style.paddingTop = PAD_OPEN + 'px';
      panel.style.paddingBottom = PAD_OPEN + 'px';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var target = panel.scrollHeight;
          if (REDUCED) {
            panel.style.opacity = '1';
            panel.style.height  = 'auto';
            panel.style.overflow = 'visible';
            delete panel.dataset.animating;
            return;
          }

          panel.style.height  = target + 'px';
          panel.style.opacity = '1';

          var off = onTransitionEndOnce(panel, function () {
            panel.style.height   = 'auto';
            panel.style.overflow = 'visible';
            delete panel.dataset.animating;
            off && off();
          });
        });
      });
    }

    function close() {
      if (panel.dataset.animating === '1' || !foot.classList.contains('is-open')) return;
      panel.dataset.animating = '1';

      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');

      panel.style.overflow = 'hidden';
      var current = panel.scrollHeight;
      panel.style.height  = current + 'px';
      panel.style.opacity = '1';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (REDUCED) {
            panel.style.height = '0px';
            panel.style.opacity = '0';
            panel.style.paddingTop = PAD_CLOSE + 'px';
            panel.style.paddingBottom = PAD_CLOSE + 'px';
            foot.classList.remove('is-open');
            delete panel.dataset.animating;
            return;
          }

          panel.style.height = '0px';
          panel.style.opacity = '0';
          var off = onTransitionEndOnce(panel, function () {
            foot.classList.remove('is-open');
            panel.style.paddingTop = PAD_CLOSE + 'px';
            panel.style.paddingBottom = PAD_CLOSE + 'px';
            delete panel.dataset.animating;
            off && off();
          });
        });
      });
    }

    function toggle() { foot.classList.contains('is-open') ? close() : open(); }

    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });
});